module.exports = {"id":"173306","name":"Cristian Ansaldi","rating":"79","photo":"./data/images/photos/4/173306.png","club":{"name":"Torino","logo":"./data/images/clubs/Torino.png"},"positions":["DG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/CristianAnsaldi0.json
// module id = 868
// module chunks = 0